const SupportStatus = {
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
  CLOSED: "CLOSED",
}

export default SupportStatus;
